import type { DirectusAsset } from '~/types/types'

export function getDirectusAssetId(asset: DirectusAsset): string {
  return typeof asset === 'string' ? asset : asset?.id || ''
}

export function getDirectusAssetAspectRatio(asset: DirectusAsset): number | undefined {
  if (typeof asset === 'string' || !asset?.width || !asset.height) return undefined

  const ratio = Number(asset.width) / Number(asset.height)
  return Number.isFinite(ratio) && ratio > 0 ? ratio : undefined
}
